import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
// Arabic — for the bilingual consent gate (RTL).
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@mantine/core/styles.css';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { fololabsTheme } from '@fololabs/design/theme';
import { App } from './App';

// Amplify is configured once inside ./auth/useAuth at module load — no
// separate call here (avoids double-configure).

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={fololabsTheme}>
      <App />
    </MantineProvider>
  </StrictMode>,
);
